import React from "react"
import { TableBody, TableRow, TableHead } from "@mui/material"
import PEReprodTableContainer from "./PEReprodTableContainer"
import { StyledTable, StyledBodyCell, StyledHeaderCell } from "../../../components/styled/StyledTableComponents"
import { getOrderedPEPackagings } from "../../../utils/packagingExecutionUtils"
import { packagingNature } from "../../../utils/packaging"
import { PE_STATUSES } from "../../../utils/packagingExecutions"
import { COLORS } from "../../../utils"

const PRReprodPackagingsField = ({
  status,
  packagings = [],
  expectedPackagingNumber = 0,
  totalRealizableNumber = 0,
  totalRealizedNumber = 0
}) => {
  const isOneLine = status !== PE_STATUSES.inProgress
  return (
    <PEReprodTableContainer
      icon="packagingNumber.svg"
      title="Nombre de barquettes"
    >
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledHeaderCell style={{ width: "21%" }}>
              Estimation
            </StyledHeaderCell>
            {packagings.map((currentPackaging, index) => {
              const label = packagingNature.find((nature) => nature.value === currentPackaging.type)?.label
              let width = "20%"
              if (label && label.toLowerCase().includes("réemployable")) {
                width = "22%"
              }
              return (
                <React.Fragment key={index}>
                  <StyledHeaderCell style={{ width }}>
                    {label}
                  </StyledHeaderCell>
                </React.Fragment>
              )
            })}
            <StyledHeaderCell style={{ width: "17%" }}>
              Total
            </StyledHeaderCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <StyledBodyCell leftEdge={true} lastTableRow={isOneLine}>
              Prévisionnelle / Théorique
            </StyledBodyCell>
              {getOrderedPEPackagings(packagings).map((currentPackaging, index) => (
                <React.Fragment key={index}>
                  <StyledBodyCell lastTableRow={isOneLine}>
                    <span style={{
                      color: currentPackaging.forecastNumber < currentPackaging.theoreticalNumber
                        ? COLORS.PRIMARY_BLUE_500
                        : "inherit"
                    }}>
                      {currentPackaging.forecastNumber}
                    </span>
                    {" / "}
                    {currentPackaging.theoreticalNumber || "-"}
                  </StyledBodyCell>
                </React.Fragment>
              ))}
            <StyledBodyCell rightEdge={true} lastTableRow={isOneLine}>
              {totalRealizableNumber && expectedPackagingNumber ? (
                <>
                  <span style={{
                    color: Math.ceil(totalRealizableNumber) < expectedPackagingNumber
                      ? COLORS.PRIMARY_BLUE_500
                      : "inherit"
                  }}>
                    {Math.ceil(totalRealizableNumber)}
                  </span>
                  {" / "}
                  {expectedPackagingNumber}
                </>
              ) : "-"}
            </StyledBodyCell>
          </TableRow>
          {/* display only for PE in progress */}
          {status === PE_STATUSES.inProgress && (
            <>
              <TableRow>
                <StyledBodyCell leftEdge={true}>
                  Réalisées
                </StyledBodyCell>
                  {packagings.map((currentPackaging, index) => (
                    <React.Fragment key={index}>
                      <StyledBodyCell>
                        {/* calculated value  */}
                        {currentPackaging.realizedNumber || "-"}
                      </StyledBodyCell>
                    </React.Fragment>
                  ))}
                <StyledBodyCell rightEdge={true}>
                  {totalRealizedNumber || "-"}
                </StyledBodyCell>
              </TableRow>
              <TableRow>
                <StyledBodyCell leftEdge={true} lastTableRow={true}>
                  Barquettes 
                  encore réalisables
                </StyledBodyCell>
                  {getOrderedPEPackagings(packagings).map((currentPackaging, index) => (
                    <React.Fragment key={index}>
                      <StyledBodyCell>
                        {currentPackaging.realizableNumber || "-"}
                      </StyledBodyCell>
                    </React.Fragment>
                  ))}
                <StyledBodyCell rightEdge={true} lastTableRow={true}>
                  {totalRealizableNumber || "-"}
                </StyledBodyCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </StyledTable>
    </PEReprodTableContainer>
	)
}

export default PRReprodPackagingsField
